import '../applied_filter_view.js.coffee';# Added by Script 
Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.AppliedCustomFacetsView extends Backbone.View
  template: JST["backbone/templates/monitoring/filters/custom_facet/applied_custom_facets"]

  initialize: (@options = {}) ->
    @searchQuery = @options.searchQuery

  render: ->
    @$el.html(@template())
    _.each @searchQuery.get('custom_facets'), (values, key) =>
      @$el.append new GenericAppliedFacetFilterView($.extend({ name: key, values: values}, @options)).render().el
    return this

  destroy: ->
    this.remove()
    return false

class GenericAppliedFacetFilterView extends Monitoring.Views.SocialContents.Filters.AppliedFilterView

  initialize: (@options = {}) ->
    super
    @name = @options.name
    @alias = _.str.humanize(@name)
    @values = @options.values

  getAppliedValues: ->
    @values

  removeFilter: (value) ->
    @searchQuery.removeCustomFacet(@name, value)

  clear: (event) =>
    @searchQuery.get('custom_facets')[@name] = []
    @eventAggregator.trigger('searchQueryChanged', @searchQuery)